import { useTranslation } from "react-i18next";
import { syncDocumentLang } from "./i18n/i18n";

/**
 * Compact flag-based language toggle (🇺🇸 / 🇰🇷).
 * Place in any header/toolbar. Persists choice to localStorage.
 */
export default function LanguageToggle({ style }: { style?: React.CSSProperties }) {
  const { i18n } = useTranslation();
  return (
    <button
      onClick={() => {
        const newLang = i18n.language === "ko" ? "en" : "ko";
        i18n.changeLanguage(newLang);
        localStorage.setItem("proteinpal_lang", newLang);
        syncDocumentLang(newLang);
      }}
      style={{
        padding: "6px 12px",
        backgroundColor: "rgba(139,92,246,0.2)",
        border: "1px solid rgba(139,92,246,0.4)",
        borderRadius: "6px",
        color: "rgba(255,255,255,0.7)",
        fontSize: "9px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        ...style,
      }}
    >
      {/* US flag */}
      <svg width="14" height="10" viewBox="0 0 28 20" style={{ opacity: i18n.language === "en" ? 1 : 0.4 }}>
        <rect width="28" height="20" rx="2" fill="#fff" />
        <rect width="28" height="20" rx="2" fill="#002868" fillOpacity="0.1" />
        {[0, 2, 4, 6, 8, 10, 12].map((i) => (
          <rect key={i} y={i * 20 / 13} width="28" height={20 / 13} fill={i % 2 === 0 ? "#B22234" : "#fff"} />
        ))}
        <rect width="11.2" height={20 * 7 / 13} fill="#002868" />
      </svg>
      <span style={{ margin: "0 2px" }}>|</span>
      {/* Korean flag */}
      <svg width="14" height="10" viewBox="0 0 28 20" style={{ opacity: i18n.language === "ko" ? 1 : 0.4 }}>
        <rect width="28" height="20" rx="2" fill="#fff" />
        <circle cx="14" cy="10" r="5" fill="#C60C30" />
        <circle cx="14" cy="8" r="2.5" fill="#003478" />
        <circle cx="14" cy="12" r="2.5" fill="#C60C30" />
      </svg>
    </button>
  );
}
